"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidFields = exports.getInvalidFields = void 0;

var _useDynamicFields = require("./useDynamicFields");

var getInvalidFields = (value, fields) => {
  var topEl = document.createElement('body');
  topEl.innerHTML = value;
  var tags = [...topEl.querySelectorAll(_useDynamicFields.PLUGIN_TAG_SELECTOR)].filter(el => el.nodeName !== '');
  var fieldsInUse = [...new Set(tags.map(el => el.dataset.id))];
  var missingFields = fieldsInUse.filter(id => !fields.find(field => field.id === id));
  return missingFields;
}; // eslint-disable-next-line import/prefer-default-export


exports.getInvalidFields = getInvalidFields;

var hasValidFields = (value, dynamicFieldOpts) => {
  var invalidFields = getInvalidFields(value, dynamicFieldOpts);
  return invalidFields.length === 0;
};

exports.hasValidFields = hasValidFields;